/* eslint-disable */
export default {
    breadcrumbsMod() {
        const breadcrumbs = $('.single-news .breadcrumbs .category');
        const oldUrl = breadcrumbs.attr('href');
        const newUrl = oldUrl.replace('category/', '');
        breadcrumbs.attr('href', newUrl);
    },

    changeGoBackButton() {
        $('.single-news.aktualnosci .post-single__footer a').attr('href', '/aktualnosci')
    },

    init() {
        this.breadcrumbsMod();
        this.changeGoBackButton();
    },

    finalize() {
        // JavaScript to be fired on all pages, after page specific JS is fired
    },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-post.js